import { mapGetters } from 'vuex';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';

const nameMap = {
    food: 'Foodie',
    kid: 'Kids',
    pet: 'Pets',
    walk: 'Walkable',
};

const iconMap = {
    food: 'icon-poi-eat',
    kid: 'icon-kid',
    pet: 'icon-dog',
    walk: 'icon-walking',
};

export default {
    name: 'propertyPoiRecord',
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getLocalHighlightScore']),
        records() {
            const scores = this.getLocalHighlightScore;
            return scores
                ? Object.keys(scores).map((key) => {
                      const value = scores[key];
                      let levelClass;
                      if (value > 84) {
                          levelClass = 'best';
                      } else if (value > 60) {
                          levelClass = 'good';
                      } else if (value > 34) {
                          levelClass = 'fair';
                      } else {
                          levelClass = 'poor';
                      }
                      return {
                          name: nameMap[key],
                          icon: iconMap[key],
                          value,
                          levelClass,
                      };
                  })
                : [];
        },
    },
};
